import React from 'react';
import { Container } from '@material-ui/core';

import CreateHeader from '@hydra/routes/create/components/CreateHeader';
import CreateMenu from '@hydra/routes/create/components/CreateMenu';

import { CreateProjectPage } from '@hydra/types/create';

export default function CreatePage ({ data }: CreateProjectPage) {
  return (
    <>
      <Container maxWidth='md'>
        <CreateHeader />
      </Container>
      <Container maxWidth='md'>
        <CreateMenu {...data} />
      </Container>
    </>
  );
}
